import { createAction } from '@reduxjs/toolkit';
export const getSubscriptionsUsageAction = createAction('subscriptionsUsage');
export const getSubscriptionsUsageResolved = createAction('subscriptionsUsage/resolved');
export const getSubscriptionsUsageRejected = createAction('subscriptionsUsage/rejected');
